import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    label: translate({ id: 'recurrenceSettings.recurrencePeriod.label' }),
    info: (count: number, recurrenceType: uui.domain.client.rm.RecurrenceType) => {
      switch (recurrenceType) {
        // daily recurrence has no period so no need for any info
        case 'DAILY':
          return ''

        case 'WEEKLY':
          return translate({
            id: 'recurrenceSettings.recurrencePeriod.info.weekly',
            values: { count },
          })

        case 'MONTHLY':
          return translate({
            id: 'recurrenceSettings.recurrencePeriod.info.monthly',
            values: { count },
          })

        case 'ANNUALLY':
          return translate({
            id: 'recurrenceSettings.recurrencePeriod.info.annually',
            values: { count },
          })
      }
    },
  }))

  return api
}
